// extracted by mini-css-extract-plugin
module.exports = {"icon":"Favorite_icon_wjAhH","favoriteIcon":"Favorite_favoriteIcon_2KL7R","link":"Favorite_link_38rUa","optionalText":"Favorite_optionalText_2RIcm"};